/**
 * Site Identity — sajt-unika värden för LifeBasicsGuide.
 *
 * Centraliserad så att övriga 6 sajter i nätverket kan ha egna värden
 * utan att råka ärva samma copy. Detta bryter strukturella fingeravtryck
 * när Google jämför domäner i samma kluster.
 *
 * När en lärdom appliceras till sajt 3–7: kopiera ENDAST denna fil och
 * skriv om värdena. All övrig kod kan vara identisk.
 */

export interface SiteIdentity {
  /** Stable internal id (ex: "lifebasicsguide") */
  id: string;
  /** Display brand name (used in footer and JSON-LD Organization) */
  brand: string;
  /** Public-facing tagline shown in hero/footer */
  tagline: string;
  /** Editorial mission angle — must differ across the network */
  editorialAngle: string;
  /** Niche-pitch used on the About page (1–2 sentences) */
  aboutPitch: string;
  /** Carl's site-specific bio variant. Should NOT match other sites verbatim. */
  founderBioVariant: string;
  /** Footer copyright suffix */
  footerSuffix: string;
  /** Primary topical territory — used for sitemap priority overrides */
  primaryTopics: string[];
  /** Sitemap priority profile — pick from preset signatures */
  sitemapProfile: 'hub-heavy' | 'article-heavy' | 'tool-heavy';
}

export const siteIdentity: SiteIdentity = {
  id: 'lifebasicsguide',
  brand: 'LifeBasicsGuide',
  tagline: 'Practical answers for the parts of adult life nobody teaches you.',
  editorialAngle:
    'We focus on the quiet practical knowledge — paperwork, repairs, money, food, civic life — that everyone is expected to know but few ever explicitly learn.',
  aboutPitch:
    'LifeBasicsGuide is a single-author publication that answers the small, embarrassing questions adults are supposed to already know. We write calmly, in full sentences, and we update articles when reality changes.',
  founderBioVariant:
    'Carl S. Molner edits LifeBasicsGuide. His focus on this site is the practical mechanics of adult life — bills, repairs, paperwork, food and civic systems — written for readers who would rather read one careful paragraph than scroll through twenty bullet points.',
  footerSuffix: 'Independent editorial, no sponsored content.',
  primaryTopics: ['life-admin', 'home-repairs', 'money-finance', 'food-cooking'],
  sitemapProfile: 'hub-heavy',
};
